core.controller('core.applicationController', ['$scope', '$rootScope', '$controller', '$state', '$mdToast', '$translate', '$window', '$location','$log', '$timeout', '$mdDialog', '$injector', 'core.objectHelper', 'applicationModel', '$mdComponentRegistry',
    function ($scope, $rootScope, $controller, $state, $mdToast, $translate, $window, $location, $log, $timeout, $mdDialog, $injector, objectHelper, applicationModel, $mdComponentRegistry) {

        //FIXME
        /*
        ApplicationModel powinien być generyczny, aby mógł działać z każdą aplikacją
        Usunąć zależności modelowe i połączyć modele i servicy z apek z corem.
        Poniższe poprawki znajdują się również w ApplicationModel i BaseModel
         */

        var userModel = {};
        var authModel = {};
        var authInterceptor = {};
        $scope.config = {};


        /**
         * detect IE
         * returns version of IE or false, if browser is not Internet Explorer
         */
        function detectIE() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                $("#ng-app").addClass('ie10');
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                $("#ng-app").addClass('ie11');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                $("#ng-app").addClass('edge');
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        }

        detectIE();

        if($injector.has('meedyConfig')) {

            $scope.config = $injector.get('meedyConfig');
            if($scope.config.COMPANY == 'null') {
                $scope.config.COMPANY = null;
            }

            angular.extend(this, $controller('meedy.applicationController', {
                $scope: $scope,
                $rootScope: $rootScope,
                $state: $state,
                $mdToast : $mdToast,
                $translate : $translate,
                $window: $window,
                $location : $location,
                $log: $log,
                $mdDialog: $mdDialog,
                objectHelper:  objectHelper,
                authModel: $injector.get('meedy.authModel'),
                config: $injector.get('meedyConfig'),
                authInterceptor: $injector.get('meedy.authInterceptor'),
                applicationModel: applicationModel,
                $mdComponentRegistry: $mdComponentRegistry
            }));

            if($injector.has('meedy.videoConsultationModel')) {
                var videoConsultationModel = $injector.get('meedy.videoConsultationModel');
                var meedyUserModel = $injector.get('meedy.userModel');
                var messagesModel = $injector.get('meedy.messagesModel');
                var meedyConfig = $injector.get('meedyConfig');
                var MAX_RECONNECT_TRIES = 5;

                // socket
                var registerSocket = function() {

                    $rootScope.lastIdOrder = undefined;

                    var socket = new SockJS(meedyConfig.SOCKET_URL.REGISTER);
                    videoConsultationModel.stompClient = Stomp.over(socket);
                    videoConsultationModel.stompClient.heartbeat.outgoing = 10000;
                    videoConsultationModel.stompClient.heartbeat.incoming = 5000;
                    videoConsultationModel.stompClient.debug = function (str, arg2) {
                        var date = new Date();
                        // console.log(date.toString() + " \n " + str + " " + arg2 );
                    };

                    videoConsultationModel.stompClient.connect({}, function(frame) {
                        $scope.reconnectCount = 0;

                        videoConsultationModel.stompClient.subscribe(meedyConfig.SOCKET_URL.PREFIX + meedyConfig.SOCKET_URL.EXAMINATION_RESULT + '-' + meedyUserModel.currentUser.id, function (greeting){
                            messagesModel.newMessages++;
                        });

                        videoConsultationModel.stompClient.subscribe(meedyConfig.SOCKET_URL.PREFIX + meedyConfig.SOCKET_URL.UPDATE_VIDEO_ATTACHMENTS_LIST + '-' + meedyUserModel.currentUser.id, function (greeting){
                            var fileDetails = objectHelper.translateObject(jQuery.parseJSON( greeting.body ), StreamingConnectionAttachedFileVO);
                            $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.ATTACHED_FILE_RETRIVED.SUCCESS, fileDetails);
                        });

                        videoConsultationModel.stompClient.subscribe(meedyConfig.SOCKET_URL.PREFIX + meedyConfig.SOCKET_URL.PATIENT_CALL + '-' + meedyUserModel.currentUser.id, function (greeting) {
                            console.log('$rootScope.lastIdOrder ' + $rootScope.lastIdOrder);
                            var details = objectHelper.translateObject(jQuery.parseJSON( greeting.body ), StreamingConnectionDetailsVO);
                            var halfHourAgo = new Date().getTime() - (1000 * 60 * 30);

                            //FIX hotfix for backend queue messages
                            if(halfHourAgo <= details.startDate && new Date().getTime() <= details.endDate) {
                                if ($rootScope.lastIdOrder) {
                                    if ($rootScope.lastIdOrder != details.idOrder) {
                                        var wrapper = new AckStatusWrapperVO();
                                        wrapper.portalIdOrder = details.idOrder;
                                        wrapper.status = Enum.MEEDY.VIDEO_CONSULTATION_ACK_STATUS.PHYSICIAN_IS_BUSY;
                                        videoConsultationModel.sendACKStatus(wrapper);
                                    }
                                } else {
                                    console.log('$mdDialog.show() popupVideoConsultationPatientCallingController');
                                    $rootScope.lastIdOrder = details.idOrder;

                                    $mdDialog.show({
                                        templateUrl: 'meedy/application/view/app/videoConsultation/popup/popup-videoConsultation-patient-calling.html',
                                        controller: 'meedy.popupVideoConsultationPatientCallingController',
                                        resolve: {
                                            details: function () {
                                                return details;
                                            }
                                        },
                                        escapeToClose: false
                                    }).then(function () {
                                    }, function (error) {
                                        $rootScope.lastIdOrder = undefined;
                                    });

                                }
                            }
                        });
                    }, function (message) {
                        $scope.reconnectCount++;

                        // if ($scope.reconnectCount > MAX_RECONNECT_TRIES) {
                        //     var internalError = new ErrorVO('T.SYSTEM.ERROR.ERROR', 'T.SYSTEM.ERROR.INTERNAL_ERROR', 'T.SYSTEM.ERROR.LOSE_SOCKET_CONNECTION');
                        //
                        //     $mdDialog.show({
                        //         templateUrl: 'meedy/application/view/app/popup/popup-error.html',
                        //         controller: 'popupErrorController',
                        //         resolve: {
                        //             error: function () {
                        //                 return internalError;
                        //             }
                        //         }
                        //     });
                        //
                        // } else {
                        //     $timeout.cancel($scope.reconnectTimeout);
                        //
                        //     $scope.reconnectTimeout = $timeout(function () {
                        //         registerSocket();
                        //     }, 5000);
                        // }
                    });
                };

                $scope.bindChange(function() { return meedyUserModel.currentUser; }, function (newValue, oldValue, $scope) {
                    var loggedUser = newValue;
                    if (loggedUser) {
                        registerSocket();
                    }
                }, $scope);

                $scope.bindChange(function() { return messagesModel.newMessages; }, function (newValue, oldValue, $scope) {
                    var number = newValue;
                    if (number > -1 && applicationModel.sideBarItems.length > 0) {
                        //2 = Constant.STATE.APP.MEEDY.MESSAGES.LIST
                        applicationModel.sideBarItems[2].badge = number;
                    }
                }, $scope);
            }


            if($scope.config && $scope.config.ANALYTICS && $injector.has('Analytics')) {
                var Analytics = $injector.get('Analytics')

                $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    Analytics.trackPage(toState.name);
                });
            }
        } else if($injector.has('edmConstant')) {

            $scope.config = $injector.get('config');
            //angular.extend(this, $controller('edm.applicationController', {
            angular.extend(this, $controller('applicationController', {
                $scope: $scope,
                $rootScope: $rootScope,
                $state: $state,
                $mdToast : $mdToast,
                $translate : $translate,
                $window: $window,
                $location : $location,
                $log: $log,
                $mdDialog: $mdDialog,
                //userModel:  $injector.get('edm.userModel'),
                userModel:  $injector.get('userModel'),
                objectHelper:  objectHelper,
                authModel: $injector.get('authModel'),
                //authModel: $injector.get('edm.authModel'),
                config: $injector.get('config'),
                authInterceptor: $injector.get('authInterceptor'),
                //authInterceptor: $injector.get('edm.authInterceptor'),
                applicationModel: applicationModel,
                $mdComponentRegistry: $mdComponentRegistry
            }));
        } else {

            authInterceptor = $injector.get('core.authInterceptor');
            $scope.config = $injector.get('coreConfig');

            $scope.bindWatchers = {};

            $scope.bindData = function (expression, target, targetScope) {
                var unwatcher = $rootScope.$watch(expression, function (newValue, oldValue, scope) {
                    targetScope[target] = newValue;
                }, true);

                if (!$scope.bindWatchers[targetScope.$id]) {
                    $scope.bindWatchers[targetScope.$id] = [];
                }

                $scope.bindWatchers[targetScope.$id].push(unwatcher);
            };

            $scope.bindChange = function (expression, handler, targetScope) {
                var unwatcher = $rootScope.$watch(expression, function (newValue, oldValue, scope) {
                    handler.call(undefined, newValue, oldValue, scope);
                }, true);

                if (!$scope.bindWatchers[targetScope.$id]) {
                    $scope.bindWatchers[targetScope.$id] = [];
                }

                $scope.bindWatchers[targetScope.$id].push(unwatcher);

                return unwatcher;
            };

            $scope.unbind = function (targetScope) {
                var scopeWatchers = $scope.bindWatchers[targetScope.$id];

                if (scopeWatchers) {
                    _.each(scopeWatchers, function (unwatcher) {
                        unwatcher();
                    });
                }

                scopeWatchers.splice(0, scopeWatchers.length);
                delete $scope.bindWatchers[targetScope.$id];
            };

            // shortened translations
            $scope.T = function (key) {
                return $translate.instant(key);
            };

            // shortened object creation
            $scope.O = function (targetClassString, obj) {
                return objectHelper.createObject(eval(targetClassString), obj);
            };

            // shortened state dynamic url
            $scope.U = function (stateString, stateParams) {
                var state = eval(stateString);
                var url = $state.href(stateString, stateParams);
                return url;
            };

            //alert template
            $scope.alert = function (title, text, confirmLabel) {
                var alert = $mdDialog.alert({
                    clickOutsideToClose: true,
                    title: $translate.instant(title),
                    content: $translate.instant(text),
                    ok: confirmLabel || $translate.instant('T.UI.APPLICATION.OK')
                });
                $mdDialog.show(alert);
            };

            // apply enums

            $scope.Enum = Enum;
            $scope.Constant = Constant;

            // data

            var goingToPreviousState = false;
            var previousStateHistory = [];
            var stateBeforeLogin = null;
            var forceStateChange = false;

            $scope.applicationName = applicationModel.applicationName;
            $scope.applicationCustomer = applicationModel.applicationCustomer;
            $scope.applicationVersion = applicationModel.applicationVersion;

            $scope.devMode = applicationModel.devMode;
            $scope.logoutUrl = $scope.config.LOGOUT_URL;

            $scope.customConfig = $scope.bindData(function () {
                return applicationModel.customConfig
            }, 'customConfig', $scope);

            $scope.currentState = $scope.bindData(function () {
                return applicationModel.currentState
            }, 'currentState', $scope);
            $scope.currentUrl = $scope.bindData(function () {
                return applicationModel.currentUrl
            }, 'currentUrl', $scope);

            $scope.isLoggedIn = $scope.bindData(function () {
                return applicationModel.isLoggedIn
            }, 'isLoggedIn', $scope);
            $scope.isLoading = $scope.bindData(function () {
                return applicationModel.isLoading
            }, 'isLoading', $scope);

            $scope.viewDirty = $scope.bindData(function () {
                return applicationModel.viewDirty
            }, 'viewDirty', $scope);
            $scope.viewReady = $scope.bindData(function () {
                return applicationModel.viewReady
            }, 'viewReady', $scope);

            $scope.bindChange(function () {
                return userModel.currentUser
            }, function onCurrentUserChange(newValue, oldValue, scope) {
                var loggedUser = newValue;
                if (loggedUser) {
                    if (loggedUser.passwordExpired) {
                        $state.go(Constant.STATE.APP.ACCOUNT.PASSWORD_CHANGE_REQUIRED);
                    }
                    applicationModel.isLoggedIn = true;
                }
            }, $scope);

            // previous state / back / dirty / module management

            $window.onbeforeunload = function (event) {
                if ($scope.viewDirty) {
                    return $scope.T('T.SYSTEM.MESSAGE.VIEW_DATA_LOSS_CONFIRMATION');
                }
            };

            /* ui router bugs workarounds - event.preventDefault() sometimes forces the url to reset to '/' */
            $rootScope.$on('$locationChangeStart', function (event, toUrl, fromUrl) {
                if (forceStateChange) {
                    forceStateChange = false;
                    if (toUrl.endsWith('#!/')) {
                        event.preventDefault();
                    }
                }
                else if (toUrl.endsWith('#!/') || toUrl.endsWith('#!') || toUrl.endsWith('#')) {
                    event.preventDefault();
                    $location.path('/home');
                }
            });

            $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                $mdDialog.cancel();
                if (toState.name && toState.name === Constant.STATE.APP.LOGOUT) {
                    // logging out
                    authModel.invalidate();
                    event.preventDefault();
                }
                if (!authInterceptor.token && !applicationModel.isLoggedIn && toState.name &&
                    (toState.name !== Constant.STATE.PRE.LOGIN) &&
                    (toState.name !== Constant.STATE.APP.ERROR.ACCESS_DENIED) &&
                    (toState.name !== Constant.STATE.APP.ERROR.NOT_FOUND) &&
                    (toState.name !== Constant.STATE.PRE.VIDEO) &&
                    (toState.name !== Constant.STATE.PRE.REGISTRATION.REGISTRATION) &&
                    (toState.name !== Constant.STATE.PRE.REGISTRATION.PERSONAL_DATA) &&
                    (toState.name !== Constant.STATE.PRE.REGISTRATION.SUBSCRIPTION_TYPE) &&
                    (toState.name !== Constant.STATE.PRE.REGISTRATION.SUMMARY)) {

                    if (toState.name != Constant.STATE.APP.HOME) {
                        stateBeforeLogin = new ApplicationStateVO(toState, toParams);
                    }

                    forceStateChange = true;
                    event.preventDefault();

                    $state.go(Constant.STATE.PRE.LOGIN);
                }


                if (userModel.currentUser && userModel.currentUser.passwordExpired && toState.name !== Constant.STATE.APP.ACCOUNT.PASSWORD_CHANGE_REQUIRED) {
                    forceStateChange = true;
                    event.preventDefault();
                    $state.go(Constant.STATE.APP.ACCOUNT.PASSWORD_CHANGE_REQUIRED);
                }
                else if (applicationModel.viewDirty) {
                    forceStateChange = true;
                    event.preventDefault();

                    $mdDialog.show(
                        $mdDialog.confirm()
                            .content('T.SYSTEM.MESSAGE.VIEW_DATA_LOSS_CONFIRMATION')
                    ).then(
                        function () {
                            applicationModel.viewDirty = false;
                            $state.go(toState.name, toParams);
                        },
                        function () {
                            // nothing
                        }
                    );
                }
            });

            $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                $mdComponentRegistry.when('left').then(function (it) {
                    it.close();
                });
                if (goingToPreviousState) {
                    goingToPreviousState = false;
                }
                else {
                    if (fromState.name) {
                        previousStateHistory.push(new ApplicationStateVO(fromState, fromParams));
                    }
                }

                applicationModel.currentState = toState;
                applicationModel.currentUrl = $location.absUrl();

                var fromModule = undefined;
                _.forEach(applicationModel.modules, function (module) {
                    var foundState = _.find(module.states, function (state) {
                        return (state == fromState.name);
                    });
                    if (foundState) {
                        fromModule = module.name;
                    }
                });

                var toModule = undefined;
                _.forEach(applicationModel.modules, function (module) {
                    var foundState = _.find(module.states, function (state) {
                        return (state == toState.name);
                    });
                    if (foundState) {
                        toModule = module.name;
                    }
                });

                if (fromModule != toModule) {
                    $rootScope.$broadcast(Event.MODULE_CHANGED, fromModule, toModule);
                }
            });

            // url debug overrides

            var debugUrlParameters = $location.search();

            if (debugUrlParameters.devMode) {
                var devMode = ($scope.$eval(debugUrlParameters.devMode) == true) ? true : false;
                applicationModel.devMode = devMode;
                $scope.devMode = applicationModel.devMode;
                $log.info('devMode override: ' + devMode);
            }
            if (debugUrlParameters.stats) {
                var stats = ($scope.$eval(debugUrlParameters.stats) == true) ? true : false;
                applicationModel.showPerformanceStats = stats;
                $log.info('  stats override: ' + stats);
            }

            // navigation shortcuts

            $scope.goBack = function (stateName, stateParams) {
                var previousState = previousStateHistory.pop();
                if (previousState) {
                    goingToPreviousState = true;
                    $state.go(previousState.getName(), previousState.params);
                } else {
                    if (stateName) {
                        $state.go(stateName, stateParams);
                    }
                }
            };

            $scope.goToUrl = function (url, newWindow) {
                $window.open(url, newWindow ? '_blank' : '_self');
            };

            $scope.goToHome = function () {
                $state.go(Constant.STATE.APP.HOME);
            };

            $scope.goToPageNotFound = function () {
                $state.go(Constant.STATE.APP.ERROR.NOT_FOUND);
            };

            $scope.goToAccessDenied = function () {
                applicationModel.viewDirty = false;
                $state.go(Constant.STATE.APP.ERROR.ACCESS_DENIED);
            };

            // loading management

            $scope.$on(Event.LOADING, function (event, isLoading) {
                if (isLoading) {
                    applicationModel.isLoading = true;
                } else {
                    applicationModel.isLoading = false;
                }
            });

            // login management

            $scope.$on(config.AUTHENTICATE_SUCCESS, function (event, user) {
                userModel.getLoggedUser();
                applicationModel.isLoggedIn = true;

                if (stateBeforeLogin) {
                    $state.go(stateBeforeLogin.getName(), stateBeforeLogin.params);
                    stateBeforeLogin = null;
                }
                else {
                    $state.go(Constant.STATE.APP.HOME);
                }
            });

            $scope.$on(config.INVALIDATE_SUCCESS, function (event, user) {
                applicationModel.isLoggedIn = false;
                sessionStorage.removeItem('token');
                $state.go(config.PRE_LOGIN);
            });

            // error / notification management

            $scope.$on(Event.ACCESS_DENIED, function (event) {
                $state.go(config.PRE_LOGIN);
            });

            $scope.$on(Event.ERROR, function (event, error) {

                $mdDialog.show({
                    templateUrl: 'core/application/view/app/popup/popup-error.html',
                    controller: 'popupErrorController',
                    resolve: {
                        error: function () {
                            return error;
                        }
                    }
                });
            });

            $scope.$on(Event.VALIDATION_ERROR, function (event, error) {

                $mdDialog.show({
                    templateUrl: 'core/application/view/app/popup/popup-error.html',
                    controller: 'popupErrorController',
                    resolve: {
                        error: function () {
                            return error;
                        }
                    }
                });
            });

            $scope.$on(Event.INTERNAL_ERROR, function (event, rejection) {
                // rejection is HttpResponseVO
                if ($scope.devMode) {
                    var internalError = new ErrorVO('T.SYSTEM.ERROR.ERROR', 'T.SYSTEM.ERROR.INTERNAL_ERROR', 'T.SYSTEM.ERROR.CONTACT_ADMINISTRATOR',
                        (rejection && rejection.data && rejection.config.url) ? [rejection.data, rejection.config.url + ' (' + rejection.config.method + ')'] : null);

                    $mdDialog.show({
                        templateUrl: 'core/application/view/app/popup/popup-error.html',
                        controller: 'popupErrorController',
                        resolve: {
                            error: function () {
                                return internalError;
                            }
                        }
                    });
                }
            });

            $scope.$on(Event.NOTIFICATION, function (event, notification) {
                $mdToast.show(
                    $mdToast.simple({
                        content: $scope.T(notification.title),
                        hideDelay: 2000,
                        position: 'top right'
                    }).theme(notification.type)
                );
            });

            $scope.notifyValidationError = function () {
                $rootScope.$broadcast(Event.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.WARNING, 'T.SYSTEM.VALIDATION.VALIDATION_MESSAGE'));
            };

            // module setup

            var states = $state.get();
            var modules = [];

            _.each(states, function (state) {
                if (state.data && state.data.module) {
                    var stateModuleName = state.data.module;

                    var existingModule = _.find(modules, function (module) {
                        return (module.name == stateModuleName);
                    });

                    if (existingModule) {
                        existingModule.states.push(state.name);
                    }
                    else {
                        var newModule = new ApplicationModuleVO();
                        newModule.name = stateModuleName;
                        newModule.states = [];
                        newModule.states.push(state.name);

                        modules.push(newModule);
                    }
                }
            });

            applicationModel.setModules(modules);

            // performance stats

            if (applicationModel.showPerformanceStats) {
                var ngStats = showAngularStats({position: 'bottomright'});
            }

            // custom config

            //applicationModel.getCustomConfig();

            //var customConfigUnwatcher = $scope.$on(Event.APPLICATION.GET_CUSTOM_CONFIG.SUCCESS, function (event, customConfig) {
            //    customConfigUnwatcher();
            //    customCSSInjector.injectCSS(customConfig);
            //});
        }
    }
]);
